<template>
  <div class="copytext">
    <textarea
      ref="text"
      v-model="data"
      class="copytext__area"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      :readonly="true"
      spellcheck="false"
      @keydown.prevent
    />
    <ElTooltip
      v-model:visible="done"
      :content="success"
      trigger="click"
      :hide-after="1000"
      placement="right"
    >
      <a
        v-if="button"
        :class="{ 'disabled': disabled }"
        class="copytext__copy-button btn btn-primary btn-sm btn-copy mr-8 mt-4 mb-4"
        @click="copy"
      >
        <span><img
          :src="monoCopyImg"
          alt="copy"
        >{{ button }}</span>
      </a>
    </ElTooltip>
    <slot name="btnRight" />
  </div>
</template>

<script>
// vue3-migration -- устранение require
import monoCopyImg from '@/assets/theme/icon/mono-copy.svg';

export default {
  name: 'Copytext',
  props: ['button', 'success', 'text', 'disabled'],
  data() {
    return {
      done: false,
    };
  },
  computed: {
    data() {
      if (Array.isArray(this.text)) return this.text.join();
      return this.text;
    },
    monoCopyImg: () => monoCopyImg,
  },
  methods: {
    copy() {
      this.done = false;
      const textarea = document.createElement('textarea');
      textarea.contentEditable = true;
      textarea.readOnly = true;
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.value = this.data;
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      document.execCommand('copy');
      textarea.remove();
      this.done = true;
      setTimeout(() => {
        this.done = false;
      }, 1400);
    },
  },
};
</script>

<style lang="scss">
.copytext {
  &__area {
    border: 2px dashed var(--main-color) !important;
    resize: none;
    width: 100%;
    height: 100px;
    padding: 16px;

    &:focus {
      outline: none;
    }
  }

  &__copy-button {
    display: inline-block;
  }

  &__btn {
    background: #fff;
    border: 2px solid #ffce06;
    text-transform: uppercase;
    font-weight: 700 !important;
    font-size: 12px !important;
    padding: 11px 22px !important;
  }

  &__done {
    position: relative;
    left: -6px;
  }
}

.perfect-scrollbar-off.modal-open {
  > .el-tooltip__popper {
    z-index: 123124343322 !important;
  }
}
</style>
